"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProducerReorderParticipantsColumnName = void 0;
var ProducerReorderParticipantsColumnName;
(function (ProducerReorderParticipantsColumnName) {
    ProducerReorderParticipantsColumnName["firstName"] = "firstName";
    ProducerReorderParticipantsColumnName["lastName"] = "lastName";
    ProducerReorderParticipantsColumnName["subtitle"] = "subtitle";
    ProducerReorderParticipantsColumnName["secondSubtitle"] = "secondSubtitle";
})(ProducerReorderParticipantsColumnName = exports.ProducerReorderParticipantsColumnName || (exports.ProducerReorderParticipantsColumnName = {}));
//# sourceMappingURL=producer-reorder-participants-column-names.js.map